import { inViewMargin } from '@helpers/animate';
import { useInView } from '@hooks/useInView';
import svgPin from '@img/icons/mapPin.svg?url';
import GoogleMap from '@stories/Components/Global/GoogleMap/GoogleMap';
import * as React from 'react';
import S from './GoogleMapWidget.styles';
const GoogleMapWidget = ({ coords, id, googleApiKey, venueDetails, }) => {
    const [refContainer, inView] = useInView({ rootMargin: inViewMargin });
    return (React.createElement(S.Container, { ref: refContainer, id: id, "data-inview": inView, flush: "top", "data-inner-width": "narrow" },
        React.createElement(S.Inner, null,
            React.createElement(S.ContentArea, null,
                venueDetails && (React.createElement(S.IntroContent, null, venueDetails && (React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: venueDetails } })))),
                React.createElement(S.MapWrapper, null,
                    React.createElement(GoogleMap, { apiKey: googleApiKey, icon: {
                            anchor: {
                                x: 37.5,
                                y: 37.5,
                            },
                            scaledSize: {
                                width: 75,
                                height: 75,
                            },
                            size: {
                                width: 75,
                                height: 75,
                            },
                            url: svgPin,
                        }, mapOptions: {
                            center: coords,
                            zoom: 13,
                        }, markers: [{ position: coords }] }))))));
};
export default GoogleMapWidget;
